
import Accordion from '~/js/modules/accordion';

//функция для сортировки доступных дат
function unique(arr) {
    let result = [];

    for (let str of arr) {
        if (!result.includes(str)) {
            result.push(str);
        }
    }

    return result;
}

const serviceRequest = document.querySelector('.js-service-request');
if (serviceRequest) {
    document.querySelectorAll('.js-request-toggle').forEach((x) => {
        x.addEventListener('click', function () {
            serviceRequest.classList.toggle('service-request--hidden');
            document.querySelector('body').classList.toggle('no-overflow');
        })
    })

    const accordions = serviceRequest.querySelectorAll(`.accordion`);
    if (accordions.length) {
        accordions.forEach((accordion) => {
            if (!accordion.classList.contains('main-nav__list')) {
                new Accordion(accordion)
            }
        });
    }

    const otherCheckbox = serviceRequest.querySelector('.js-checkbox-other label');
    let otherText;

    if (otherCheckbox) {
        otherText = otherCheckbox.parentElement.querySelector('div');
        //Для показа поля ввода после клику на "другое"
        otherCheckbox.addEventListener('click', function () {
            if (otherText) {
                otherText.classList.toggle('active');
                if (!otherText.getAttribute('field-required')) {
                    otherText.setAttribute('field-required', 'true');
                } else {
                    otherText.removeAttribute('field-required');
                }
            }
        })
    }
    const submitButton = serviceRequest.querySelector('.js-submit-form');
    const serviceRequestBlocks = serviceRequest.querySelectorAll('.service-request__block');
    const finalMessage = serviceRequest.querySelector('.js-final-message span');

    let api_url;
    let api_create_event;
    if (window.location.host == 'www.dohod.ru') {
        api_url = "https://api.dohod.ru/dohod/api/public/sched/get-busy-false-slots-year-month-day";
        api_create_event = "https://api.dohod.ru/dohod/api/public/event/create-event";
    } else {
        api_url = "https://test-api.dohod-am.ru/dohod/api/public/sched/get-busy-false-slots-year-month-day";
        api_create_event = "https://test-api.dohod-am.ru/dohod/api/public/event/create-event";
    }

    //обработка календаря, получение дат на запись
    const calendarInput = serviceRequest.querySelector('.js-input-calendar');
    const calendarOutput = serviceRequest.querySelector('.js-output-calendar');
    if (calendarInput) {
        let responseFreeSLots;
        let textBtns;
        calendarInput.addEventListener('change', function () {
            //Чтобы нельзя было отправить форму без выбора времени
            submitButton.setAttribute('disabled', true);

            calendarOutput.innerHTML = "<span>Пожалуйста, подождите, идёт загрузка доступных дат...</span>";

            const date = calendarInput.value.split('-');
            //замена 01-09 на 1-9, под работу АПИ
            date[1] = date[1] < 10 ? date[1].replace('0', '') : date[1];
            //формируем тело запроса
            const qr_data = {
                "year": date[0],
                "month": date[1],
                "day": date[2],
            }

            const xhr = new XMLHttpRequest()
            xhr.open('POST', api_url, false);
            xhr.setRequestHeader("Accept", "application/json");
            xhr.setRequestHeader("Content-Type", "application/json");
            try {
                xhr.send(JSON.stringify(qr_data));
            }
            catch (exception) {
                console.log(exception);
                calendarOutput.innerHTML = "<span>Произошла ошибка при попытке выбора доступной даты. Попробуйте обновить страницу или обратиться в службу поддержки.</span>";
            }

            if (xhr.status == 200) {
                calendarOutput.innerHTML = "<span>Выберите удобное для вас время:</span>";
                calendarOutput.classList.add("active");

                let response = JSON.parse(xhr.responseText);
                if (response.length == 0) {
                    calendarOutput.innerHTML = "<span>На данную дату запись недоступна.</span>";
                }

                //отсортировать не по айди брони, а по времени
                response.sort((a, b) => a.dateFrom.localeCompare(b.dateFrom));

                //Убираем занятые слоты
                responseFreeSLots = response.filter(function (element) {
                    return element.busy == false;
                });

                //Берем время для записи в кнопку, сразу выбирая только уникальное время
                textBtns = unique(responseFreeSLots.map(function (item) {
                    //Пример входных данных - "dateFrom: '2023-03-24T16:00:00'" становится "16:00"
                    return item.dateFrom;
                }));

                //вывод радио-кнопок для выбора даты
                 textBtns.forEach((element, index) => {
                     const newDiv = document.createElement("div");

                     const btn = document.createElement("input");
                     btn.type = "radio";
                     btn.name = "time";
                     btn.id = index;
                     const label = document.createElement("label");
                     label.htmlFor = index;
                     label.innerHTML = element.split('T')[1].substring(0, 5);

                     newDiv.appendChild(btn);
                     newDiv.appendChild(label);

                     newDiv.onclick = function () {
                         submitButton.removeAttribute('disabled');
                     }
                     calendarOutput.appendChild(newDiv);
                 });
                //для вывода ошибок при выборе неверной даты
                const errorMsg = document.createElement("span");
                errorMsg.className = "js-error-msg";
                calendarOutput.appendChild(errorMsg);
            }
        })
        let isSent = false;

        const form = serviceRequest.querySelector('.js-form-create-event')
        if (form) {
            form.addEventListener('submit', function (e) {
                //не так быстро, Субмит Формович!
                e.preventDefault();
                //защита от дублирования формы при выборе разных дат
                if (isSent) {
                    return false;
                }
                const purposeButtons = serviceRequest.querySelector('.js-purpose-buttons')
                const purposeButtonsList = purposeButtons.querySelectorAll('.radio-button>input:checked')
                const purposeValues = [];
                if (purposeButtonsList.length > 0) {
                    //запись значений для выбора типа операции
                    purposeButtonsList.forEach((x) => {
                        purposeValues.push(x.value);
                    })
                    purposeButtons.parentElement.classList.remove('invalid');
                } else {
                    //Если не выбрана ни одна цель
                    purposeButtons.parentElement.classList.add('invalid');
                }
                //Когда выбрана цель "другое"
                //Когда переделают поле "другое", раскомментировать инвалидов
                if (otherText.getAttribute('field-required') == 'true') {
                    //проверка на пустое поле
                    /*if (otherText.querySelector('input').value.length > 0) {
                        otherText.classList.remove('invalid');
                    } else {
                        otherText.classList.add('invalid');
                    }*/

                    //поле комментарий должно быть не пустым (сейчас)
                    //document.querySelector(".js-comment-field").parentElement.setAttribute("required", "required");
                } else {
                    //otherText.classList.remove('invalid');
                    //document.querySelector(".js-comment-field").parentElement.removeAttribute("required", "required");
                }

                const form_inputs = form.querySelectorAll('.js-input, .js-select')
                for (const inpt of form_inputs) {
                    //проверка на пустое поле
                    if ((inpt.querySelector('input')) && (inpt.querySelector('input').hasAttribute('data-value'))) {
                        if (inpt.querySelector('input').value == '') {
                            inpt.classList.add(`invalid`);
                            inpt.setAttribute('data-invalid', 'Это поле не заполнено');
                        } else {
                            //inpt.classList.remove(`invalid`);
                            //inpt.setAttribute('data-invalid', '');
                        }
                    }
                }

                //проверка на наличие хотя бы одного неправильного поля
                if (form.querySelector('.invalid')) {
                    form.setAttribute('input-success', false);
                } else {
                    form.setAttribute('input-success', true);
                }

                const checkbox = form.querySelector('.js-checkbox');
                if (checkbox) {
                    if (!checkbox.querySelector('input').checked) {
                        const text = 'Нужно подтвердить согласие';
                        checkbox.classList.add(`invalid`);
                        checkbox.setAttribute('data-invalid', text);
                        form.setAttribute('checkbox-success', false);
                    } else {
                        checkbox.classList.remove(`invalid`);
                        checkbox.setAttribute('data-invalid', '');
                        form.setAttribute('checkbox-success', true);
                    }
                }

                //действие при успешном заполнении формы
                if ((form.getAttribute('input-success') == 'true') && (form.getAttribute('checkbox-success') == 'true')) {

                    //ищем id выбранного промежутка времени
                    const checkedTime = calendarOutput.querySelector('input[name="time"]:checked').id;

                    //по id находим строку из отфильтрованного запроса
                    const result = responseFreeSLots.filter(el => el.dateFrom == textBtns[checkedTime].toString());

                    //Берем данные с формы для формирования запроса
                    const formData = new FormData(form);
                    //для записи в type legalId
                    const sourceLabel = serviceRequest.querySelector('input[name="source"]:checked').parentElement.querySelector('label');
                    const legalId = parseInt(formData.get("source"));
                    //ФИО делим на Фамилию Имя Отчество для записи в запросе, если физ лицо
                    const nameFull = legalId == 1 ? "" : formData.get("name").split(" ");
                    //для надписи о занятых слотах
                    const checkedTimeElement = calendarOutput.querySelector('input[name="time"]:checked');

                    //Готовим тело запроса на запись
                    let checkIn = {
                        "personInfoDto": {
                            "firstName": nameFull[1] ? nameFull[1] : "",
                            "patronymic": nameFull[2] ? nameFull[2] : "",
                            "lastName": nameFull[0] ? nameFull[0] : "",
                            "nameOfCompany": nameFull[0] ? "" : formData.get("name"),
                            "email": formData.get("mail"),
                            "phoneNumber": formData.get("tel").replace(/\D+/g, ''),
                            "contractNumber": formData.get("contractNumber"),
                        },
                        "slotDto": {
                            "idSlot": result[0].idSlot,
                            "dateFrom": result[0].dateFrom,
                            "dateEnd": result[0].dateEnd,
                            "busy": false
                        },
                        "legalDto": {
                            "legalId": legalId,
                            "type": sourceLabel.innerHTML
                        },
                        "status": "PENDING",
                        "company": "DOHOD",
                        "comment": formData.get("comment")
                    }

                    let typeOfOperationDto = [];
                    purposeValues.forEach((x) => {
                        typeOfOperationDto.push({
                            "typeId": parseInt(x),
                            "note": "string",
                            "typeOfOperation": "string"
                        })
                    })
                    checkIn.typeOfOperationDto = typeOfOperationDto;

                    let xhrEvent = new XMLHttpRequest()
                    xhrEvent.open('POST', api_create_event, false);
                    xhrEvent.setRequestHeader("Accept", "application/json");
                    xhrEvent.setRequestHeader("Content-Type", "application/json");

                    try {
                      if (formData.get("smart-token")) {
                        xhrEvent.send(JSON.stringify(checkIn))
                      } else {
                        calendarOutput.innerHTML = "<span>Произошла ошибка валидации. Попробуйте обновить страницу или обратиться в службу поддержки.</span>";
                      }
                    }
                    catch (exception) {
                        isSent = false;
                        console.log(exception);
                        calendarOutput.innerHTML = "<span>Произошла ошибка при попытке выбора доступной даты. Попробуйте обновить страницу или обратиться в службу поддержки.</span>";
                    }

                    if (xhrEvent.status == 200) {
                        isSent = true;
                        //Закрываем форму, открываем окно с тысячей благодарностей
                        serviceRequestBlocks.forEach((item) => {
                            item.classList.toggle("hidden");
                        })
                        //Вставляем выбранное время в сообщение об успешной отправке
                        const splitDate = textBtns[checkedTime].split('T');
                        finalMessage.innerHTML = splitDate[1].substring(0, 5) + '<br/>' + splitDate[0].split('-').reverse().join('.');
                    } else if (xhrEvent.status == 400) {

                        if (result.length > 1) {
                            checkIn.slotDto = {
                                "idSlot": result[1].idSlot,
                                "dateFrom": result[1].dateFrom,
                                "dateEnd": result[1].dateEnd,
                                "busy": false
                            },

                                xhrEvent = new XMLHttpRequest()
                            xhrEvent.open('POST', api_create_event, false);
                            xhrEvent.setRequestHeader("Accept", "application/json");
                            xhrEvent.setRequestHeader("Content-Type", "application/json");

                            try {
                                xhrEvent.send(JSON.stringify(checkIn));
                            }
                            catch (exception) {
                                isSent = false;
                                console.log(exception);
                                calendarOutput.innerHTML = "<span>Произошла ошибка при попытке выбора доступной даты. Попробуйте обновить страницу или обратиться в службу поддержки.</span>";
                            }
                            if (xhrEvent.status == 200) {
                                //Закрываем форму, открываем окно с тысячей благодарностей
                                serviceRequestBlocks.forEach((item) => {
                                    item.classList.toggle("hidden");
                                })
                                //Вставляем выбранное время в сообщение об успешной отправке
                                const splitDate = textBtns[checkedTime].split('T');
                                finalMessage.innerHTML = splitDate[1].substring(0, 5) + '<br/>' + splitDate[0].split('-').reverse().join('.');
                            } else if (xhrEvent.status == 400) {
                                isSent = false;
                                calendarOutput.querySelector('.js-error-msg').innerHTML = "<span>К сожалению, это время уже забронировано.</span>";
                                checkedTimeElement.parentElement.style.color = '#F56C6C';
                                checkedTimeElement.setAttribute('disabled', 'disabled');
                            } else {
                                isSent = false;
                                calendarOutput.innerHTML = "<span>Произошла ошибка при попытке выбора доступной даты. Попробуйте обновить страницу или обратиться в службу поддержки.</span>";
                            }
                        } else {
                            isSent = false;
                            calendarOutput.querySelector('.js-error-msg').innerHTML = "<span>К сожалению, это время уже забронировано.</span>";
                            checkedTimeElement.parentElement.style.color = '#F56C6C';
                            checkedTimeElement.setAttribute('disabled', 'disabled');
                        }
                    } else {
                        isSent = false;
                      calendarOutput.innerHTML = "<span>Произошла ошибка при попытке выбора доступной даты. Попробуйте обновить страницу или обратиться в службу поддержки.</span>";
                      if (formData.get("smart-token")) {

                      } else {
                        calendarOutput.innerHTML = "<span>Произошла ошибка валидации. Попробуйте обновить страницу или обратиться в службу поддержки.</span>";
                      }
                    }
                }
            })
        }
    } else {
        //Если сервис недоступен
        calendarOutput.innerHTML = "<span>Произошла ошибка при попытке выбора доступной даты. Попробуйте обновить страницу или обратиться в службу поддержки.</span>";
        calendarOutput.classList.add("active");
    }
}
